  let data= {
    production:(url=document.location.protocol+'//'+window.location.hostname)=>{
        // www.hxmxfj.com
        // m.hxmxfj.com ,
        //     portal.hxmxfj.com
        // websocket.hxmxfj.com
        let  reg = /(^www\.hxmxfj\.com)|(^http\:\/\/www\.hxmxfj\.com)|(^https\:\/\/www\.hxmxfj\.com)|(^m\.hxmxfj\.com)|(^http\:\/\/m\.hxmxfj\.com)|(^https\:\/\/m\.hxmxfj\.com)/ig
        // 正式环境      sfasign=34d2f66bd0ef014c10
        return{
            flag:reg.test(url),
            sfasign:'34d2f66bd0ef014c10',
            hostname:url
        }

        return  reg.test(url)
    },
    test:(url=document.location.protocol+'//'+window.location.hostname)=>{
        // 测试环境    sfasign=a6e18c68b67ab862
        // cs.hxmxfj.com
        // csm.hxmxfj.com ,
      //http://csportal.hxmxfj.com
        let  reg = /(^http\:\/\/localhost)|(^http:\/\/192\.168\.)|(^http:\/\/127\.0\.)|(^cs\.hxmxfj\.com)|(^http\:\/\/cs\.hxmxfj\.com)|(^https\:\/\/cs\.hxmxfj\.com)|(^csm\.hxmxfj\.com)|(^http\:\/\/csm\.hxmxfj\.com)|(^https\:\/\/csm\.hxmxfj\.com)/ig
        //     csportal.hxmxfj.com
        // cswebsocket.hxmxfj.com
        return{
            flag:reg.test(url),
            sfasign:'a6e18c68b67ab862',
            hostname:url
        }
    },
    localhost:(url=document.location.protocol+'//'+window.location.hostname)=>{
    // 测试环境    sfasign=a6e18c68b67ab862
    // cs.hxmxfj.com
    // csm.hxmxfj.com ,
    //http://csportal.hxmxfj.com
    let  reg = /(^http\:\/\/localhost)|(^http:\/\/192\.168\.)/ig
    //     csportal.hxmxfj.com
    // cswebsocket.hxmxfj.com
    return{
      flag:reg.test(url),
      sfasign:'a6e18c68b67ab862',
      hostname:url
    }
  }
}

export  default   data;
  // data.production('http://cs.hxmxfj.com')
  // data.test('http://cs.hxmxfj.com')



// WEBPACK FOOTER //
// ./src/assets/js/matchDomainName.js